import { Link } from 'react-router-dom'

export default function CallToAction() {
  return (
    <section className="mx-4 sm:mx-8 mb-12 sm:mb-20 p-8 sm:p-16 bg-gradient-to-br from-green-900/30 to-green-950/50 border border-green-900/40 text-center">
      <h2 className="text-2xl sm:text-3xl font-black uppercase tracking-tight mb-4 text-gray-900 dark:text-white">
        Ready to Get Started?
      </h2>
      <p className="text-gray-500 dark:text-gray-400 mb-6 sm:mb-8 max-w-md mx-auto text-sm sm:text-base">
        Join the thousands of Mighty Mufulira Wanderers Supporters Society family.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
        <Link
          to="/register"
          className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors"
        >
          Register Now
        </Link>
        <Link
          to="/login"
          className="border border-gray-300 dark:border-white/20 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white px-8 py-4 font-bold uppercase tracking-widest text-sm transition-colors"
        >
          Sign In
        </Link>
      </div>
    </section>
  )
}
